import React from 'react';
import DishesSingle from './DishesSingle';
import { dishes } from './dishes';
import { connect } from 'react-redux';
import { setDish } from '../gui/actions';
import importAllImages from '../assets/functions/importAllImages';
import getImage from '../assets/functions/getImage';
// import * as _ from 'lodash';

const images = importAllImages(require.context('../assets/img/dishes', false, /\.(png|jpe?g|svg)$/));

class DishesContainer extends React.Component {

	hasWarning(dish) {
		const warnings = dish.warnings || [];
		for (let i = 0; i < warnings.length; i++) {
			const hasWarning = this.props.gui.warnings[warnings[i]];
			if (hasWarning) {
				return true;
			}
		}
		return false;
	}

	warningList(dish) {
		let warningList = [];
		if (this.hasWarning(dish)) {
			for (let i = 0; i < dish.warnings.length; i++) {
				const activeWarning = this.props.gui.warnings[dish.warnings[i]];
				if(activeWarning) {
					warningList.push(dish.warnings[i])
				}
			}
		}
		return warningList;
	}

	render() {
		return(
			<div style={{marginBottom: '80px'}} className="flex-col">
				{dishes[this.props.dishes] && dishes[this.props.dishes].map((dish, i) => {
					const hasWarning = this.hasWarning(dish);
					return (
						<DishesSingle
							key={i}
							image={getImage({dish, images})}
							name={dish.name}
							link={'/detail/'}
							dish={dish}
							benefits={dish.benefits}
							warningList={this.warningList(dish)}
							order={!hasWarning? i: i+10}
							setDish={this.props.setDish} />
						)
					}
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	gui: state.gui,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  setDish(obj) {
    dispatch(setDish(obj))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DishesContainer);




// WEBPACK FOOTER //
// ./src/dishes/DishesContainer.js